// Copyright (c) 2020 Deere & Company

export default {
    name: 'OPEN_PART_REQUESTS',
    onEnter: (nextState, replace) => replace('/part-requests/open'),
    path: 'open-part-requests'
};



// WEBPACK FOOTER //
// ./src/routes/tabm/reports/open-part-requests.js